import { render } from "./PublicationsList.vue?vue&type=template&id=7fb0c401"
import script from "./PublicationsList.vue?vue&type=script&lang=js"
export * from "./PublicationsList.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__